import React, { useId } from "react";
import PropTypes from "prop-types";

const ListIcon = ({ selected, width, height, className, ...props }) => {
  const id = useId().replace(/:/g, "");
  const clipId = `list-clip-${id}`;

  return (
    <svg width={width || 24} height={height || 24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M3 5.00024H3.01M3 12.0002H3.01M3 19.0002H3.01M8 5.00024H21M8 12.0002H21M8 19.0002H21"
          stroke="white"
          strokeOpacity={selected ? 1 : 0.5}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

ListIcon.propTypes = {
  selected: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

ListIcon.defaultProps = {
  selected: false,
  width: undefined,
  height: undefined,
  className: "",
};

export default ListIcon;
